import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getAllOperationTypes from '../../services/operationType/getAllOperationTypes'

export function * fetchOperationTypeAll () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const operationTypeAllCombo = yield call(getAllOperationTypes, auth.token)
    yield put(fetchCombosSuccess({ operationTypeAllCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchOperationTypeAll () {
  yield takeLatest(combosActionTypes.FETCH_OPERATION_TYPE_ALL, fetchOperationTypeAll)
}
